import { THistoryDiffData } from '../../../../types/history';
import { TSiteProcessHistoryData } from '../../../../types/process';
import { getSiteProcessStatusName } from '../../../../utils';
import { TSiteProcessHistoryDiffApiResponse } from '../../../..//types/process';

export const useHooks = () => {
  const createHistoryDiffData = (
    targetId: number,
    title: string,
    hasDiff: boolean,
    target: string | number | null | undefined,
    previous: string | number | null | undefined
  ) => {
    return {
      targetId,
      title,
      hasDiff,
      target,
      previous
    };
  };

  const createHistoryDiffDataList = (
    apiResponseHistoryDiff: TSiteProcessHistoryDiffApiResponse
  ) => {
    const target = apiResponseHistoryDiff.data.target_site_process_history;
    const previous = apiResponseHistoryDiff.data.previous_site_process_history;
    const historyDiffDataList: Array<THistoryDiffData> = [];
    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '案件名',
        target?.constructs?.id !== previous?.constructs?.id,
        target?.constructs?.name,
        previous?.constructs?.name
      )
    );

    // 小工程の時のみ大工程を表示
    if (
      target?.parent_site_process !== null &&
      (previous === null || previous?.parent_site_process !== null)
    ) {
      historyDiffDataList.push(
        createHistoryDiffData(
          target?.id,
          '大工程',
          target?.parent_site_process?.id !== previous?.parent_site_process?.id,
          target?.parent_site_process?.name,
          previous?.parent_site_process?.name
        )
      );
    }

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '工程名',
        target?.site_process_name !== previous?.site_process_name,
        target?.site_process_name,
        previous?.site_process_name
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '担当者',
        target?.charge_user?.id !== previous?.charge_user?.id,
        target?.charge_user?.name,
        previous?.charge_user?.name
      )
    );

    const hasDiffPeriod =
      target?.start_date !== previous?.start_date ||
      target?.end_date !== previous?.end_date;
    let targetText: string | null = `${target?.start_date || ''}～${
      target?.end_date || ''
    }`;
    if (targetText === '～') {
      targetText = null;
    }
    let previousText: string | null = `${previous?.start_date || ''}～${
      previous?.end_date || ''
    }`;
    if (previousText === '～') {
      previousText = null;
    }

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '期間',
        hasDiffPeriod,
        targetText,
        previousText
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '計画人工',
        target?.planned_man_day !== previous?.planned_man_day,
        target?.planned_man_day,
        previous?.planned_man_day
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '実働人工',
        target?.actual_man_day !== previous?.actual_man_day,
        target?.actual_man_day,
        previous?.actual_man_day
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        '備考',
        target?.note !== previous?.note,
        target?.note,
        previous?.note
      )
    );

    historyDiffDataList.push(
      createHistoryDiffData(
        target?.id,
        'ステータス',
        target?.status !== previous?.status,
        getSiteProcessStatusName(target?.status),
        getSiteProcessStatusName(previous?.status)
      )
    );

    return historyDiffDataList;
  };

  const createHistoryDataText = (
    apiResponseHistory: TSiteProcessHistoryData
  ): string => {
    let text = apiResponseHistory.site_process_name;
    if (apiResponseHistory.parent_site_process_name) {
      text = `${apiResponseHistory.parent_site_process_name}の${text}`;
    }
    return text;
  };

  return {
    createHistoryDiffDataList,
    createHistoryDataText
  };
};
